import { tryGetCompanyPolicyById, allCompanyContributions } from "EntitiesApi/Selectors";
import isProduction from "Utils/isProduction";

import { TIERED_CONTRIBUTION_ROLES, TIERED_CONTRIBUTIONS_SORTING_ORDER } from "Common/Constants";
// - TODO HM - We might be able to memoization this selector
// Look into selector factories https://redux.js.org/usage/deriving-data-selectors#selector-factories
// - Also, inAbTest (lowercase b)
export const inABTest = (state: State, test: string) => {
  if (!state.abTests || state.abTests[test] === undefined) {
    return false;
  }
  return state.abTests[test] === "show";
};
export const showMobileCompare = (state: State) => {
  const testName = "quote_compare_mobile";

  if (!isProduction) {
    return true;
  }
  return inABTest(state, testName);
};
export const showExpandingFaq = (state: State) => {
  const testName = "quote_page_faqs";

  if (!state.abTests || state.abTests[testName] === undefined) {
    return false;
  }
  return state.abTests[testName] === "show_expanding";
};
export const getMultiVariantAbTest = (state: State, test: string) => {
  if (!state.abTests || state.abTests[test] === undefined) {
    return false;
  }
  return state.abTests[test];
};
// DONT USE
export const getHasTieredContributions = (state) => {
  const policy = tryGetCompanyPolicyById(state, state.companyPolicyId);
  return policy?.hasTieredContributions;
};
// TODO we have a getNonTieredContribution method in EmployerApplication/Selectors.js
export const getOrderedTieredContributions = (state) =>
  allCompanyContributions(state)
    .filter((contribution) => contribution.active && !!contribution.role)
    .sort((a, b) => TIERED_CONTRIBUTIONS_SORTING_ORDER.indexOf(a.role) - TIERED_CONTRIBUTIONS_SORTING_ORDER.indexOf(b.role));
export const produceContributionTierOptions = (state) => {
  const contributionTiers = getOrderedTieredContributions(state);
  return contributionTiers.reduce((options, tier) => {
    const label = TIERED_CONTRIBUTION_ROLES[tier.role];
    return [...options, [tier.id, label]];
  }, []);
};
export const produceContributionId = (tierName, state) => {
  const contribution = allCompanyContributions(state).find((contribution) => contribution?.role === tierName);
  return contribution?.id;
};
export const produceContributionTierLabel = (contributionId, state) => {
  const contribution = allCompanyContributions(state).find((contribution) => contribution?.id === contributionId);
  return TIERED_CONTRIBUTION_ROLES[contribution?.role];
};
export const getSiteLogo = (state: State) => state?.siteConfig?.partner_logo;
export const getSiteColor = (state: State) => state?.siteConfig?.color;
export const getSitePartnerName = (state: State) => state?.siteConfig?.partner_name;
